// extracted by mini-css-extract-plugin
export default {"SeparatorTitle":"style_SeparatorTitle__8uEFS","container":"style_container__CiXnO","dark":"style_dark__W+W8+","tilte":"style_tilte__c9yeQ"};